import { options } from './oauth-options';

export default class OAuthProviderSelectorController {
  constructor() {
    this.options = options;
  }
}
